import { render } from "./Play.vue?vue&type=template&id=4985fb5c&scoped=true&ts=true"
import script from "./Play.vue?vue&type=script&lang=ts"
export * from "./Play.vue?vue&type=script&lang=ts"

import "./Play.vue?vue&type=style&index=0&id=4985fb5c&scoped=true&lang=css"
import "./Play.vue?vue&type=style&index=1&id=4985fb5c&lang=scss&scoped=true"

import exportComponent from "/Users/alessiomealli/WebstormProjects/switaly/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4985fb5c"]])

export default __exports__